/* Copyright (c) 2017 Backpack Health LLC */
/* global window */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { mobileShareFile } from '../../utilities/MobileUtil';

class FileSharing extends Component {
  componentDidMount() {
    const message = this.props.intl.formatMessage({
      id: 'share.androidNoSupportedApp.message.text',
    });
    window.cordova.plugins.MMS.setError(message);
  }
  executeSharing() {
    mobileShareFile(this.props.file, this.props.downloadUrl, this.props.intl);
  }
  render() {
    return (
      <div />
    );
  }
}

FileSharing.propTypes = {
  intl: PropTypes.object,
  file: PropTypes.object,
  downloadUrl: PropTypes.string,
};

export default injectIntl(FileSharing);
